$(function () {
    const switcher = $('.language-switcher'),
        currentLang = '.language-current';

    switcher.on('click', currentLang, function (e) {
        e.stopPropagation();
        switcher.toggleClass('open');

        const isOpen = switcher.hasClass('open');
        $(this).attr('aria-expanded', isOpen);
    });

    $(document).on('click', function (e) {
        if (!$(e.target).closest('.language-switcher').length) {
            if (switcher.hasClass('open')) {
                switcher.removeClass('open');
                switcher.children(currentLang).attr('aria-expanded', false);
            }
        }
    });

    const menu = $('nav .menu');
    const mobileMenuQuery = window.matchMedia('(max-width: 1199px)');
    let savedScrollY = 0;

    function scrollToTopInstant() {
        const scrollingElement = document.scrollingElement || document.documentElement;
        const previousBehavior = scrollingElement.style.scrollBehavior;
        scrollingElement.style.scrollBehavior = 'auto';
        window.scrollTo(0, 0);
        scrollingElement.style.scrollBehavior = previousBehavior;
    }

    function lockBodyScroll() {
        if (!mobileMenuQuery.matches) {
            return;
        }

        savedScrollY = window.scrollY || window.pageYOffset || 0;
        $('body').addClass('menu-open').css({
            position: 'fixed',
            top: `${-savedScrollY}px`,
            left: 0,
            right: 0,
            width: '100%',
        });
    }

    function unlockBodyScroll() {
        if (!mobileMenuQuery.matches) {
            $('body').removeClass('menu-open').css({
                position: '',
                top: '',
                left: '',
                right: '',
                width: '',
            });
            return;
        }

        $('body').removeClass('menu-open').css({
            position: '',
            top: '',
            left: '',
            right: '',
            width: '',
        });
        window.scrollTo(0, savedScrollY);
    }

    menu.on('click', '.burger', function () {
        const willOpen = !menu.hasClass('open');

        if (willOpen) {
            scrollToTopInstant();
            menu.toggleClass('open');
            lockBodyScroll();
        } else {
            menu.toggleClass('open');
            unlockBodyScroll();
        }

        $(this).attr('aria-expanded', willOpen);
    });
});
